import { Currency } from '@quickbit/qb-design-system';
import { OrderStatus, Wallet } from 'types';
import { fetchAPI } from './fetchAPI';

export interface Refund {
  receivedAmount: string;
  refundTransactionId?: string;
}
export interface ManualRefund {
  createdAt: Date;
  refundAmount: string;
  refundTransactionId?: string;
}

export interface OrderResponse {
  amount: number;
  customerFee?: number;
  currency: Currency;
  merchantId: string;
  merchantName: string;
  hideQbBrand: boolean;
  hideFiatAmount: boolean;
  uuid: string;
  createdAt: Date;
  status: OrderStatus;
  refund?: Refund;
  manualRefund?: ManualRefund;
  redirectUrl?: string;
  failureRedirectUrl?: string;
  refundRedirectUrl?: string;
}

export interface OrderOverviewResponse {
  order: OrderResponse;
  wallets: Wallet[];
  merchantLogo?: {
    logoUrl: string;
    enabled: boolean;
  };
}

export const getOrder = async (orderId: string) => {
  return await fetchAPI<OrderOverviewResponse>(`v1/order/${orderId}/overview`);
};

export const cancelOrder = async (orderId: string) => {
  return await fetchAPI<OrderOverviewResponse>(`v1/order/${orderId}/overview`, {
    method: 'DELETE',
  });
};
